Pixlee.module("MosaicApp.Show", function(Show, App, Backbone, Marionette, $) {
    var size;
    Show.currentFrame = 0;
    Show.largeFrame = false;
    Backbone.Marionette.MultiRegion = Backbone.Marionette.Region.extend({
        open: function(view) {
            this.$el.append(view.el);
        },

        destroy: function() {
            var view = this.currentView;
            if (!view || view.length <= 0) {
                return;
            }

            if (!_.isArray(view)) {
                this.currentView = view = [view];
            }

            _.each(view, function(v) {
                if (v.destroy) {
                    v.destroy();
                }
                this.trigger('view:destroy', v);

                delete v;
            }, this);

            this.currentView = [];

            this.$el.empty();
        },

        append: function(view) {
            this._ensureElement();

            view.render();
            this.open(view);

            if (view.onShow) {
                view.onShow();
            }
            view.trigger('show');

            if (this.onShow) {
                this.onShow(view);
            }
            this.trigger('view:show', view);

            this.currentView = this.currentView || [];

            if (!_.isArray(this.currentView)) {
                this.currentView = [this.currentView];
            }

            this.currentView.push(view);
        }
    });
    Show.Layout = App.Views.Layout.extend({
        template: require('./templates/layout.jst.ejs'),
        regions: {
            widget_header_region: '#widget_header_region',
            interactive_region: '#interactive_region',
            frame: {
                regionClass: Backbone.Marionette.MultiRegion,
                selector: '.mosaic_frame'
            }
        },
        events: {
            'click .load_more': function() {
                var _this = this;
                this.$el.find('.load_more').addClass('loading');
                Show.currentFrame = 0;
                this.trigger('loadMore');
                App.commands.execute('load:more', _this.collection.pluck('album_photo_id'), true);
            }
        },
        ui: {
            mosaic_widget: '#mosaic_widget',
            widget_header_region: '#widget_header_region',
            interactive_region: '#interactive_region'
        },
        onShow: function() {
            this.listenTo(this.collection, {
                'sync': this.onSync
            }, this);
            this.onLoadingOptionsChange();
        },
        onSync: function() {
            var mosaicMinimum = gon.current_account.id === 1202 || gon.current_account.id === 1458 || gon.current_account.id === 1468 ? 9 : 16;
            if (this.collection.length < ((Show.numFrames + 1) * mosaicMinimum) && !this.collection.next) {
                if (this.collection.length % mosaicMinimum !== 0 || this.collection.length < (mosaicMinimum * 2)) {
                    this.$el.find('.load_more').hide();
                } else if (this.collection.length % mosaicMinimum === 0) {
                    this.$el.find('.load_more').removeClass('loading');
                    this.$el.find('.load_more').hide();
                }
            }
        },
        onLoadingOptionsChange: function() {

            if (App.displayOptions.get('widget_loadingOption_showHide')) {
                this.$el.find('#mosaic_control').show();

            } else {
                this.$el.find('#mosaic_control').hide();
            }
        },
        onPatchLoadMore: function() {
            this.trigger('loadMore');
        }
    });
    Show.PhotoView = App.Views.ItemView.extend({
        className: 'photo_block',
        tagName: 'li',
        behaviors: {
            Share: {},
            Vote: {},
            Lightbox: {},
            UpdateThumbnailCss: {}
        },
        initialize: function() {
            if (!App.displayOptions.get('widget_loadingOption_showHide')) {
                this.on('change:image', this.changeImage, this);
            }
            if (this.model.get('is_starred')) {
                this.$el.addClass('starred');
            }
            gon.currentMosaicImages = [];
        },
        getTemplate: function() {
            if ((Show.currentFrame < 3) || Show.largeFrame) {
                Show.currentFrame += 1;
                Show.largeFrame = false;
                return require('../../common/templates/v2/_xl_photo_item.jst.ejs');
            } else {
                Show.currentFrame += 1;
                return require('../../common/templates/v2/_photo_item.jst.ejs');
            }
        },
        changeImage: function() {
            var _this = this;
            var index = this.collection.indexOf(this.model);
            this.collection.remove(this.collection.at(index), {
                silent: true
            });

            //make a local array which we use so that dupes don't slow us down
            if (gon.currentMosaicImages.length <= 1) {
                gon.currentMosaicImages = gon.fresh_images.slice();
            }

            var model = gon.currentMosaicImages[0];

            //check the grid data tags for current photo id
            var currentGrid = this.$el.parents('ul').find('.photo_item_container');
            var dup = currentGrid.filter('[data-id="' + model.get('id') + '"]');

            //if it's already in there don't add it and move it to the back
            if (dup.length) {
                gon.currentMosaicImages.shift();
                return;
            }

            //update the data tag
            this.$el.parent().attr('data-id', model.get('id'));

            // model.collection = this.model.collection;
            model.collection = _.clone(model.collection);


            this.collection.add(model, {
                at: index,
                silent: true
            });
            _this.model = model;
            _this.addView.model = this.model;
            gon.currentMosaicImages.shift();

            var currentView;
            var inactive;

            if (this.activeView) {
                currentView = this;
                inactive = this.addView;
            } else {
                currentView = this.addView;
                inactive = this;
            }

            inactive.$el.removeClass('starred');
            if (inactive.model.get('is_starred')) {
                inactive.$el.addClass('starred');
            }

            var helpers = _this.templateHelpers;
            for (var i in this.model.attributes) {
                helpers[i] = this.model.attributes[i];
            }
            var url = helpers.thumbnail.call(helpers);

            var image = new Image();

            image.src = url;
            inactive.render();

            image.onload = function() {
                inactive.$el.animate({
                    opacity: 1
                }, 1000, function() {
                    inactive.$el.css('z-index', '1');
                    inactive.activeView = true;
                });
                currentView.$el.animate({
                    opacity: 0
                }, 1000, function() {
                    currentView.activeView = false;
                    currentView.render();
                    currentView.$el.css('z-index', '0');
                });
            };

        },
        onShow: function() {
            this.$el.wrap("<div data-id='" + this.model.get('id') + "' class='photo_item_container'></div>");
            this.$el.css({
                'position': 'absolute',
                'top': '0px',
                'left': '0px'
            });
            this.activeView = true;
            if (!App.displayOptions.get('widget_loadingOption_showHide')) {
                this.addView();
            }
        },
        addView: function() {
            if (!App.displayOptions.get('widget_loadingOption_showHide')) {
                this.addView = new Show.PhotoView({
                    model: this.model
                });
                this.$el.after(this.addView.$el);
                this.$el.css('z-index', '1');

                this.addView.render();
                this.addView.$el.css({
                    'position': 'absolute',
                    'top': '0px',
                    'left': '0px',
                    'opacity': "0",
                    'z-index': "0"
                });
                this.addView.activeView = true;
            }
        },
        templateHelpers: {
            decodeUtf8: function(string) {
                return App.request('decode:utf8', string);
            }
        }
    });
    Show.PhotoView.include(['PhotoViewHelpers', 'ReviewHelpers']);

    Show.MosaicCollection = App.Views.CollectionView.extend({
        childView: Show.PhotoView,
        className: 'clearfix',
        tagName: 'ul',
        behaviors: {
            CollectionVote: {},
            AppendUploaderTiles: {}
        },
        initialize: function() {
            gon.fresh_images = [];
        },
        onShow: function() {
            $('#widget').attr('alt', App.altText);
        },
        onAddChild: function(item) {
            item.collection = this.collection;
        },
        onRender: function() {
            var _this = this;
            var mosaicMinimum = gon.current_account.id === 1202 || gon.current_account.id === 1458 || gon.current_account.id === 1468 ? 9 : 16;
            if (this.collection.length > 0) {
                if (this.collection.length > mosaicMinimum) {
                    gon.fresh_images = this.collection.last(this.collection.length - mosaicMinimum);
                    this.collection.reset(this.collection.first(mosaicMinimum), {
                        silent: true
                    });
                }
                if (!App.displayOptions.get('widget_loadingOption_showHide')) {
                    gon.currentLength = this.collection.length;
                    this.options.referenceCollection.next = this.collection.next;
                    this.options.referenceCollection.nextPage();
                    this.options.referenceCollection.on('sync', this.refreshReferenceCollection, this);
                }
            }
        },
        refreshReferenceCollection: function() {
            gon.currentLength += this.options.referenceCollection.length;
            this.options.referenceCollection.models.reverse();
            this.options.referenceCollection.each(function(model) {
                if (model.attributes && (model.attributes.source_url || model.attributes.data_file_name)) {
                    gon.fresh_images.push(model);
                }
            });
            this.setTimer();
        },
        showLoadMore: function() {
            this.$el.find('#mosaic_control').show();
        },
        hideLoadMore: function() {
            this.$el.find('#mosaic_control').hide();
        },
        setTimer: function() {
            if (!App.displayOptions.get('widget_loadingOption_showHide')) {
                var _this = this;
                clearTimeout(gon.timer);
                if (gon.fresh_images.length === 0) {
                    this.options.referenceCollection.reset();
                    this.options.referenceCollection.models = [];
                    if (!_this.options.referenceCollection.next) {
                        gon.currentLength = 0;
                        // this.options.referenceCollection.goTo(1);
                        return false;
                    } else {
                        this.options.referenceCollection.nextPage();
                        return false;
                    }
                } else {
                    gon.timer = setTimeout(function() {
                        var elems = [];
                        _.each(_this.children._views, function(view) {
                            if (view.$el.is(':visible')) {
                                elems.push(view);
                            }
                        });
                        if (elems.length > 0 && gon.fresh_images[0] && gon.fresh_images[0].get('is_starred')) {
                            var random = Math.floor(Math.random() * Math.min(3, elems.length));
                            if (random < 3) {
                                Show.largeFrame = true;
                            }
                            elems[random].trigger('change:image');
                        } else if (elems.length > 0) {
                            var random = Math.floor(Math.random() * Math.min(15, elems.length));
                            if (random < 3) {
                                Show.largeFrame = true;
                            }
                            elems[random].trigger('change:image');
                        }
                        _this.setTimer();
                    }, 2000);
                }
            }
        }
    });
    Show.MosaicCollection.include(['tabindexHelpers', 'designEditorCollectionHelpers', 'socialShareHelpers']);

    Show.HeaderView = App.Views.ItemView.extend({
        template: require('../../common/templates/v2/_header.jst.ejs'),
        id: 'widget_header',
        behaviors: {
            Upload: {},
            ShowPdpCaption: {}
        }
    });

    Show.HeaderView.include(['StandaloneHeaderHelpers']);

});